/**
 * Sends visitors who log in or create an account from the rewards page back
 * to it, instead of Shopify's default: /account after logging in, the home
 * page after signing up.
 *
 * - On the rewards page (any page with a loyalty section) the account
 *   drawer's login and sign-up forms get a return_to field pointing at the
 *   page, and the page's path is kept in sessionStorage.
 * - Yotpo's buttons and the FAQ links open the full /account/login and
 *   /account/register pages instead, the FAQ ones in a new tab, which starts
 *   with empty sessionStorage. There the referrer decides: coming from the
 *   rewards page sends the visitor back to it; coming from another account
 *   page (a failed login re-renders the form, or the visitor switched between
 *   login and sign-up) keeps the stored path; anywhere else clears it.
 */
(() => {
  const KEY = 'ylty:return-to';
  // /pages/rewards, with an optional language or market prefix (/en, /en-de)
  const REWARDS_PAGE = /^(\/[a-z]{2}(-[a-z]{2})?)?\/pages\/rewards\/?$/i;
  // /account/login, /account/register, and /account (a failed sign-up renders there)
  const ACCOUNT_PAGE = /\/account(\/login|\/register)?\/?$/;

  const stored = {
    get() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } },
    set(path) { try { sessionStorage.setItem(KEY, path); } catch (e) { /* storage blocked */ } },
    clear() { try { sessionStorage.removeItem(KEY); } catch (e) { /* storage blocked */ } },
  };

  // Login and sign-up forms only. The account-activation form (also a
  // create_customer form) already has its own return_to and keeps it.
  const setReturnTo = (path) => {
    document.querySelectorAll('form#customer_login, form#create_customer').forEach((form) => {
      if (form.querySelector('input[name="return_to"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      input.value = path;
      form.appendChild(input);
    });
  };

  const referrerPath = () => {
    try {
      const referrer = new URL(document.referrer);
      return referrer.origin === location.origin ? referrer.pathname : '';
    } catch (e) {
      return ''; // no referrer
    }
  };

  const init = () => {
    if (document.querySelector('.ylty-section')) {
      stored.set(location.pathname);
      setReturnTo(location.pathname);
      return;
    }

    const from = referrerPath();
    const previous = stored.get();
    let back = null;
    if (from && (from === previous || REWARDS_PAGE.test(from))) back = from;
    else if (ACCOUNT_PAGE.test(from)) back = previous;

    if (back) {
      stored.set(back);
      setReturnTo(back);
    } else {
      stored.clear();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
